import 'newrelic';
import { type AppProps } from 'next/app';
import { ErrorBoundary } from '../components';

import '../styles/global.scss';

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <ErrorBoundary>
      <Component {...pageProps} />
    </ErrorBoundary>
  );
}

export default MyApp;
